const ID = "cy-public-fonts";
/** Poppins is the approved display face of the public pages (headline, tagline). Loaded only when a public page shows. Idempotent. */
export const ensurePublicFonts = (): void => {
  if (typeof document === "undefined" || document.getElementById(ID)) return;
  const link = document.createElement("link");
  link.id = ID; link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Inter:wght@400;500;600;700&family=Rubik:wght@400;500;600;700&display=swap";
  document.head.appendChild(link);
};
